export const renderContext = {
	context: null
}